/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rolled_Back_By_LabelInputs */

const vi_note_rolled_back_by_label = /** @type {(inputs: Note_Rolled_Back_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã rollback bằng phiếu điều chỉnh`)
};

/**

* @param {Note_Rolled_Back_By_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rolled_back_by_label = /** @type {((inputs?: Note_Rolled_Back_By_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rolled_Back_By_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rolled_back_by_label(inputs)
});